export const StatusEnum = Object.freeze({
  PENDING: "PENDING",
  PARTIALLY_ORDERED: "PARTIALLY_ORDERED",
  FULLY_ORDERED: "FULLY_ORDERED",
});
